import { Link } from "react-router-dom";
import Logo from "./Logo";

const COLS = [
  {
    title: "Ürün",
    links: [
      { to: "/features", label: "Özellikler" },
      { to: "/docs", label: "Dokümantasyon" },
      { to: "/developers", label: "Geliştiriciler" },
      { to: "/security", label: "Güvenlik" },
    ],
  },
  {
    title: "Kurumsal",
    links: [
      { to: "/about", label: "Hakkımızda" },
      { to: "/contact", label: "İletişim" },
      { to: "/register", label: "Hemen Başla" },
      { to: "/login", label: "Giriş Yap" },
    ],
  },
  {
    title: "Yasal",
    links: [
      { to: "/terms", label: "Kullanım Şartları" },
      { to: "/privacy", label: "Gizlilik Politikası" },
      { to: "/refund-policy", label: "İade Politikası" },
      { to: "/aml-policy", label: "AML Politikası" },
      { to: "/risk-disclosure", label: "Risk Bildirimi" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card/40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-16">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <Logo />
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground max-w-xs">
              İşletmeniz için hızlı, güvenli ve özelleştirilebilir kripto ödeme altyapısı.
            </p>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <h4 className="text-sm font-semibold">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-border pt-8">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Coinbuy.org — Tüm hakları saklıdır.</p>
          <p className="text-xs text-muted-foreground">Türkiye merkezli kripto ödeme altyapısı</p>
        </div>
      </div>
    </footer>
  );
}
